export const isBuildOwnerInProject = (project, currentUser) => {
  if (project) {
    return searchForBuildOwnerInProject(project.root_build.builds, currentUser);
  }
  return false;
};

function searchForBuildOwnerInProject(builds, currentUser) {
  if (builds) {
    for (let i = 0; i < builds.length; i++) {
      if (builds[i]) {
        if (currentUser && builds[i].build_owners && builds[i].build_owners.filter(bowner => { return bowner.id == currentUser.id || parseInt(bowner, 10) == currentUser.id; }).length) {
          return true;
        }
        else {
          searchForBuildOwnerInProject(builds[i].builds, currentUser);
        }
      }
    }
  } else {
    return false;
  }
}

  //important for build owner task permissions because the build owner restrictions only
  //apply to build owners that are not in their primary company
export function isBuildOwnerInVendorCompany(currentCompany, currentUser) {
  const currentUserCompanyId = currentUser.primary_company ? currentUser.primary_company.id : parseInt(localStorage.primary_company_id, 10);
  const currentCompanyId = currentCompany ? currentCompany.id : parseInt(localStorage.current_company_id, 10);
  // return isBuildOwnerInProject(props.selectedProject, props.currentUser) && currentUserCompanyId != currentCompanyId
  return currentUserCompanyId != currentCompanyId;
}

export function isBuildOwnerOfBuild(build, currentUserId) {
  return build && build.build_owners && build.build_owners.filter(bowner => { return bowner.id == currentUserId; }).length;
}

export function addBuildOwnersToUserAssignments(user_build_assignments, buildOwnersToAdd) {
    //replace all user_build_assignments of type build_owner with the BOs in my state
  user_build_assignments = user_build_assignments.filter(uba => uba.assignment_type != 'build_owner');

    //map over all new BOs and push new BOs into the edited build user build assignments
  if (buildOwnersToAdd.length) {      
    buildOwnersToAdd.forEach(BO => {
      if (BO.toBeDeleted) {
        user_build_assignments.push({
          user: BO,
          user_id: BO.id,
          toBeDeleted: true, 
          assignment_type: 'build_owner',
        });
      } else {
        user_build_assignments.push({
          user: BO,
          user_id: BO.id,
          toBeAdded: true, 
          assignment_type: 'build_owner',
        });
      }
    });
  }

  return user_build_assignments;
}

export function canBuildOwnerAssign(assignedUsers, parentCompanyId) {
    //check if the only assignments on task is parent user, if so, do not allow show button
  const companyIds = assignedUsers.map(user => user.companies && typeof user.companies[0] == 'number' ? user.companies[0] : user.companies[0].id);

    //do not allow build owner to assign if all assignments are parent company users
  return companyIds.length && companyIds.every(id => id == parentCompanyId) ? false : true;
}                                                                                                                                                                                                                                                                                                                            



// WEBPACK FOOTER //
// ./src/helpers/permissions/BuildOwnerPermissionsUtil.js